import {
  DialogContentText as MuiDialogContentText,
  DialogContentTextProps as MuiDialogContentTextProps,
  styled,
} from "@mui/material";

const StyledDialogContentText = styled(MuiDialogContentText)(() => ({
  // ... existing styles
}));

interface DialogContentTextProps extends MuiDialogContentTextProps {
  children: React.ReactNode;
}

export const DialogContentText: React.FC<DialogContentTextProps> = ({ children, ...props }) => {
  return <StyledDialogContentText {...props}> {children}</StyledDialogContentText>;
};

export default DialogContentText;
